import {parseSearch} from "@pg-mono/request";

export const parseQueryParams = (paramsQuery: string) => {
    const parsedValues = parseSearch(paramsQuery);
    const utmKeys = ["fbclid", "utm_campaign", "utm_content", "utm_id", "utm_medium", "utm_source", "utm_term"];

    const utmValues = utmKeys.reduce((acc: {[key: string]: string}, key: string) => {
        if (parsedValues[key]) {
            acc[key] = parsedValues[key] as string;
        }
        return acc;
    }, {});

    const parsedParams = {
        ...utmValues,
        ...((parsedValues.area_0 || parsedValues.area_1) && {
            area: {
                lower: parsedValues.area_0 || "",
                upper: parsedValues.area_1 || ""
            }
        }),
        ...((parsedValues.rooms_0 || parsedValues.rooms_1) && {
            rooms: {
                lower: parseInt(parsedValues.rooms_0 as string) || "",
                upper: parseInt(parsedValues.rooms_1 as string) || ""
            }
        }),
        price: {
            lower: parsedValues.price_0 || "",
            upper: parsedValues.price_1 || ""
        },
        ...(parsedValues.construction_end_date && {
            construction_end_date: [parseInt(parsedValues.construction_end_date as string)]
        }),
        ...(parsedValues.distance && {
            distance: parseInt(parsedValues.distance as string)
        }),
        ...(parsedValues.floors && {
            floors: [parsedValues.floors].flat()
        }),
        ...(parsedValues.kitchen_type && {
            kitchen_type: [parsedValues.kitchen_type].flat()
        }),
        ...(parsedValues.world_directions && {
            world_directions: [parsedValues.world_directions].flat()
        }),
        ...(parsedValues.rooms_area_type_selected && {
            rooms_area_type_selected: [parsedValues.rooms_area_type_selected].flat()
        }),
        ...(parsedValues.search && {
            search: {
                regions: [parsedValues.search].flat().map((id) => ({id: parseInt(id as string)})),
                label: ""
            }
        }),
        ...(parsedValues.instalment && {instalment: parsedValues.instalment})
    };
    return parsedParams;
};
import {parseSearch} from "@pg-mono/request";

export const parseQueryParams = (paramsQuery: string) => {
    const parsedValues = parseSearch(paramsQuery);
    const utmKeys = ["fbclid", "utm_campaign", "utm_content", "utm_id", "utm_medium", "utm_source", "utm_term"];

    const utmValues = utmKeys.reduce((acc: {[key: string]: string}, key: string) => {
        if (parsedValues[key]) {
            acc[key] = parsedValues[key] as string;
        }
        return acc;
    }, {});

    const parsedParams = {
        ...utmValues,
        ...((parsedValues.area_0 || parsedValues.area_1) && {
            area: {
                lower: parsedValues.area_0 || "",
                upper: parsedValues.area_1 || ""
            }
        }),
        ...((parsedValues.rooms_0 || parsedValues.rooms_1) && {
            rooms: {
                lower: parseInt(parsedValues.rooms_0 as string) || "",
                upper: parseInt(parsedValues.rooms_1 as string) || ""
            }
        }),
        price: {
            lower: parsedValues.price_0 || "",
            upper: parsedValues.price_1 || ""
        },
        ...(parsedValues.construction_end_date && {
            construction_end_date: [parseInt(parsedValues.construction_end_date as string)]
        }),
        ...(parsedValues.distance && {
            distance: parseInt(parsedValues.distance as string)
        }),
        ...(parsedValues.floors && {
            floors: [parsedValues.floors].flat()
        }),
        ...(parsedValues.kitchen_type && {
            kitchen_type: [parsedValues.kitchen_type].flat()
        }),
        ...(parsedValues.world_directions && {
            world_directions: [parsedValues.world_directions].flat()
        }),
        ...(parsedValues.rooms_area_type_selected && {
            rooms_area_type_selected: [parsedValues.rooms_area_type_selected].flat()
        }),
        ...(parsedValues.search && {
            search: {
                regions: [parsedValues.search].flat().map((id) => ({id: parseInt(id as string)})),
                label: ""
            }
        }),
        ...(parsedValues.instalment && {instalment: parsedValues.instalment})
    };
    return parsedParams;
};
